import { format, isToday, isYesterday, parseISO } from 'date-fns'

export const formatTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  const date = new Date(0, 0, 0, hours, minutes, remainingSeconds)

  return hours && hours > 0
    ? format(date, "hh':'mm':'ss")
    : format(date, "mm':'ss")
}

export const dateStringToSwedishLocaleTimeZoneString = (
  dateTimeString: string,
  formatOptions: {
    year?: 'numeric'
    month?: 'numeric' | 'short' | 'long'
    day?: 'numeric'
    hour?: 'numeric'
    minute?: 'numeric'
    second?: 'numeric'
  },
) =>
  parseISO(dateTimeString).toLocaleString('sv-SE', {
    timeZone: 'Europe/Stockholm',
    ...formatOptions,
  })

export const todayAsSwedishLocaleString = () => {
  const todayString = new Date().toISOString()

  return dateStringToSwedishLocaleTimeZoneString(todayString, {})
}

export const formattedLocaleString = (dateTimeString: string) => {
  return dateStringToSwedishLocaleTimeZoneString(dateTimeString, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

export const premieresTodaySwedishTimezone = (startTime: string) =>
  isToday(dateStringToSwedishLocaleTimeZoneString(startTime, {}))

export const calculateNewsTimeLabel = (startTime: string) => {
  const premieresToday = premieresTodaySwedishTimezone(startTime)
  const premieredYesterday = isYesterday(
    dateStringToSwedishLocaleTimeZoneString(startTime, {}),
  )

  let dateString = ''

  if (premieresToday) {
    dateString = `Idag kl. ${dateStringToSwedishLocaleTimeZoneString(
      startTime,
      {
        minute: 'numeric',
        hour: 'numeric',
      },
    )}`
  } else if (premieredYesterday) {
    dateString = `Igår kl. ${dateStringToSwedishLocaleTimeZoneString(
      startTime,
      {
        minute: 'numeric',
        hour: 'numeric',
      },
    )}`
  } else {
    dateString = dateStringToSwedishLocaleTimeZoneString(startTime, {
      day: 'numeric',
      month: 'long',
    })
  }

  return dateString
}

export const convertSecondsToHHMMSS = (secondsInput: string) => {
  const sec_num = parseInt(secondsInput, 10) // don't forget the second param
  const hours = Math.floor(sec_num / 3600)
  const minutes = Math.floor((sec_num - hours * 3600) / 60)
  const seconds = sec_num - hours * 3600 - minutes * 60

  let hourAsString = hours.toString()
  let minutesAsString = minutes.toString()
  let secondsAsString = seconds.toString()

  if (hours < 10) {
    hourAsString = '0' + hours
  }
  if (minutes < 10) {
    minutesAsString = '0' + minutes
  }
  if (seconds < 10) {
    secondsAsString = '0' + seconds
  }

  if (hours === 0) {
    return minutesAsString + ':' + secondsAsString
  }

  return hourAsString + ':' + minutesAsString + ':' + secondsAsString
}

export const convertHHMMSSToSeconds = (input: string) => {
  let hours = 0
  let minutes = 0
  let seconds = 0

  const values = input.split(':')

  if (values.length - 1 === 3) {
    hours = parseInt(values[0], 10) * 60 * 60
    minutes = parseInt(values[1], 10) * 60
    seconds = parseInt(values[2], 10)
  } else {
    minutes = parseInt(values[0], 10) * 60
    seconds = parseInt(values[1], 10)
  }

  return hours + minutes + seconds
}
